import 'hammerjs'

import { enableProdMode } from '@angular/core'
import { platformBrowser } from '@angular/platform-browser'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

import * as Sentry from '@sentry/angular'
import { BehaviorSubject } from 'rxjs'
import { version } from './assets/version'

export const baseConfig = new BehaviorSubject<any>('')

fetch('/assets/configuration.json?v=1')
    .then((res) => res.json())
    .then((config) => {
        baseConfig.next(config)

        if (config.environment !== 'Local' || (config.environment === 'Local' && config.enableSentryOnDev)) {
            Sentry.init({
                dsn: config.sentry_dsn,
                environment: config.environment,
                tracesSampleRate: config.sentry_tracesSampleRate,
                replaysSessionSampleRate: config.sentry_replaysSessionSampleRate,
                replaysOnErrorSampleRate: config.sentry_replaysOnErrorSampleRate,
                release: version
            })
        }

        if (environment.production) {
            enableProdMode()
        }

        platformBrowser()
            .bootstrapModule(AppModule)
            .catch((err) => console.error(err))
    })
